import React from 'react';
import { string, bool } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { useParams, useLocation } from '@thd-olt-component-react/router';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';

export const StoreFinderBreadcrumbs = ({
  includeDirectory, pageName
}) => {
  const {
    storeNumber,
    storeZip,
    state,
    name,
    city
  } = useParams();
  const path = useLocation();

  const breadcrumb = [
    {
      label: 'Home',
      url: '/'
    },
    {
      label: 'Store Locator',
      url: '/l/store-locator'
    },
    {
      label: 'Store Directory',
      url: '/l/storeDirectory'
    },
  ];

  if (includeDirectory) {
    const directoryBreadcrumb = [
      ...(state ? [{
        label: `${state}`,
        url: `/l/${state}`
      }] : []),
      ...(name ? [{
        label: `${name}`,
        url: `/l/${name}/${state}/${city}/${storeZip}/${storeNumber}`
      }] : []),
    ];
    breadcrumb.push(...directoryBreadcrumb);
  }

  if (pageName) {
    const isReviewsPage = path.pathname.toLowerCase().includes('reviews');
    const label = `${pageName}`;
    const url = isReviewsPage ? `/l/${name}/${state}/${city}/${storeZip}/${storeNumber}/reviews/1` : `${path.pathname}`;

    breadcrumb.push({ label, url })
  }

  return (
    <div className="sui-py-3 sui-w-full">
      <Breadcrumbs
        staticCrumbs={breadcrumb}
      />
    </div>
  );
};

StoreFinderBreadcrumbs.displayName = 'StoreFinderBreadcrumbs';
StoreFinderBreadcrumbs.propTypes = {
  includeDirectory: bool,
  pageName: string,
}
StoreFinderBreadcrumbs.defaultProps = {
  includeDirectory: false,
  pageName: '',
}

StoreFinderBreadcrumbs.dataModel = extend({},
  Breadcrumbs
);
